import { motion } from "framer-motion";
import { ArrowRight, Mail } from "lucide-react";
import { Link } from "react-router-dom";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta" className="section relative">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="relative overflow-hidden rounded-[2rem] border border-white/10 px-8 py-16 md:p-20 text-center"
          style={{
            background:
              "radial-gradient(ellipse at top, rgba(0,85,255,0.25), transparent 60%), radial-gradient(ellipse at bottom right, rgba(0,229,255,0.18), transparent 60%), #0a0a0a",
          }}
        >
          <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[40rem] h-[40rem] radial-glow opacity-50 pointer-events-none" />

          <h2 className="relative font-display text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-tight leading-[1.05] max-w-4xl mx-auto">
            Let's build your{" "}
            <span className="text-gradient-brand">digital growth system</span>.
          </h2>
          <p className="relative mt-6 text-white/65 text-lg max-w-2xl mx-auto">
            Book a free 30-minute strategy call. We'll map your fastest path to
            more traffic, more leads and more revenue — no obligation.
          </p>

          <div className="relative mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#audit"
              data-testid="final-cta-primary"
              className="group inline-flex items-center justify-center gap-2 bg-gradient-to-r from-blue-600 to-cyan-400 text-black font-semibold px-7 py-4 rounded-full hover:shadow-[0_0_40px_rgba(0,229,255,0.45)] transition-all duration-300"
            >
              Book Free Audit
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </a>
            <Link
              to="/contact"
              data-testid="final-cta-secondary"
              className="inline-flex items-center justify-center gap-2 bg-white/5 border border-white/10 text-white font-semibold px-7 py-4 rounded-full hover:bg-white/10 transition-all duration-300 backdrop-blur-md"
            >
              <Mail className="w-4 h-4" />
              Contact Us
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
